module.exports = __webpack_public_path__ + "img/_bolivia.c369ac72.png";